import React, { useEffect, useMemo, useState } from 'react'
import { Cascader, Tooltip } from 'antd'
import { useSelector } from 'dva'
import styles from '../../index.less'
import { DvaState } from '@/types/react-redux'

interface Props {
  initialValue: string[]
  onChange: (value: string[]) => void
}

export interface SnickType {
  value: string
  label: string
  children: SnickType[]
}

export type SnicksMapType = {
  // valueMap用于将后端返回的数据转换成Cascader组件需要的数据格式
  valueMap: Map<string, string[]>
  // flatMap用于将Cascader组件的value转换成后端需要的数据格式
  flatMap: Map<string, { value: string; label: string }[]>
}

export const snickToOption = (snick: any) => ({
  value: snick.id,
  label: snick.snick,
})

export const formatSnicks = (list: any[]): SnickType[] => {
  return (
    list?.map(i => {
      const children = i.snicks
        ? i.snicks.map(snickToOption)
        : formatSnicks(i.subs || i.sub_groups || [])
      return {
        value: i.id || i.department_id,
        label: i.name,
        children,
      }
    }) || []
  )
}

export default function SnickCascader(props: Props) {
  const { initialValue, onChange } = props
  const [value, setValue] = useState<string[][]>([])
  const { snicks, snicksMap } = useSelector((state: DvaState) => state.alarmRules)
  const loading = useSelector(store => store.loading.effects['alarmRules/fetchSnicks'])

  useEffect(() => {
    if (snicksMap.valueMap.size === 0 || initialValue?.length === 0) return

    setValue(initialValue?.map(v => snicksMap.valueMap.get(v) || []) || [])
  }, [initialValue, snicksMap])

  const finalValue = useMemo(
    () =>
      value
        .map(v => v[v.length - 1])
        .filter(v => snicksMap.flatMap.has(v))
        .map(v => snicksMap.flatMap.get(v) || [])
        .flat(),
    [value, snicksMap]
  )

  const renderMaxTag = () => (
    <Tooltip
      title={<div className={styles.tooltipTitle}>{finalValue.map(v => v.label).join('、')}</div>}
    >
      <span>{`+${finalValue.length} ...`}</span>
    </Tooltip>
  )

  return (
    <Cascader
      multiple
      showSearch
      value={value}
      maxTagCount={0}
      options={snicks}
      loading={loading}
      disabled={loading}
      style={{ width: 135 }}
      placeholder="请选择子账号"
      maxTagPlaceholder={renderMaxTag}
      showCheckedStrategy={Cascader.SHOW_CHILD}
      onBlur={() => {
        onChange(finalValue.map(v => v.value))
      }}
      onChange={(val: any) => {
        setValue(val)
        if (val.length === 0) {
          onChange([])
        }
      }}
    />
  )
}
